"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESimpleTriggerMissfireRules = exports.ETriggerMissfireRules = exports.EIntervalType = exports.ECalendarType = exports.ETriggerType = exports.EActionType = void 0;
var EActionType;
(function (EActionType) {
    EActionType[EActionType["InvokeAction"] = 0] = "InvokeAction";
    EActionType[EActionType["RestApiAction"] = 1] = "RestApiAction";
    EActionType[EActionType["ProcessStartAction"] = 2] = "ProcessStartAction";
})(EActionType || (exports.EActionType = EActionType = {}));
var ETriggerType;
(function (ETriggerType) {
    ETriggerType[ETriggerType["Simple"] = 0] = "Simple";
    ETriggerType[ETriggerType["DailyTimeInterval"] = 1] = "DailyTimeInterval";
    ETriggerType[ETriggerType["Cron"] = 2] = "Cron";
})(ETriggerType || (exports.ETriggerType = ETriggerType = {}));
var ECalendarType;
(function (ECalendarType) {
    ECalendarType[ECalendarType["Daily"] = 0] = "Daily";
    ECalendarType[ECalendarType["Monthly"] = 1] = "Monthly";
    ECalendarType[ECalendarType["Weekly"] = 2] = "Weekly";
    ECalendarType[ECalendarType["Holiday"] = 3] = "Holiday";
    ECalendarType[ECalendarType["Cron"] = 4] = "Cron";
    ECalendarType[ECalendarType["Annual"] = 5] = "Annual";
})(ECalendarType || (exports.ECalendarType = ECalendarType = {}));
var EIntervalType;
(function (EIntervalType) {
    EIntervalType[EIntervalType["Minute"] = 0] = "Minute";
    EIntervalType[EIntervalType["Hour"] = 1] = "Hour";
    EIntervalType[EIntervalType["Day"] = 2] = "Day";
})(EIntervalType || (exports.EIntervalType = EIntervalType = {}));
var ETriggerMissfireRules;
(function (ETriggerMissfireRules) {
    ETriggerMissfireRules[ETriggerMissfireRules["DoNothing"] = 0] = "DoNothing";
    ETriggerMissfireRules[ETriggerMissfireRules["FireAndProceed"] = 1] = "FireAndProceed";
    ETriggerMissfireRules[ETriggerMissfireRules["Ignore"] = 2] = "Ignore";
})(ETriggerMissfireRules || (exports.ETriggerMissfireRules = ETriggerMissfireRules = {}));
var ESimpleTriggerMissfireRules;
(function (ESimpleTriggerMissfireRules) {
    ESimpleTriggerMissfireRules[ESimpleTriggerMissfireRules["FireNow"] = 0] = "FireNow";
    ESimpleTriggerMissfireRules[ESimpleTriggerMissfireRules["Ignore"] = 1] = "Ignore";
    ESimpleTriggerMissfireRules[ESimpleTriggerMissfireRules["NextWithExistingCount"] = 2] = "NextWithExistingCount";
    ESimpleTriggerMissfireRules[ESimpleTriggerMissfireRules["NextWithRemainingCount"] = 3] = "NextWithRemainingCount";
    ESimpleTriggerMissfireRules[ESimpleTriggerMissfireRules["NowWithExistingCount"] = 4] = "NowWithExistingCount";
    ESimpleTriggerMissfireRules[ESimpleTriggerMissfireRules["NowWithRemainingCount"] = 5] = "NowWithRemainingCount";
})(ESimpleTriggerMissfireRules || (exports.ESimpleTriggerMissfireRules = ESimpleTriggerMissfireRules = {}));
//# sourceMappingURL=enums.js.map